module.exports = __webpack_public_path__ + "static/media/Ogg-Regular.18b7bbe2.woff2";